module.exports = __webpack_public_path__ + "static/media/vk.f1edfb75.svg";